/**
 * Display names for catalog models that arrived named after a manufacturer's
 * URL: the spec forge admits a new product under its page slug and upper-cases
 * it as if it were a model code, so "BulletCam HLVF (5 MP)" reached the picker
 * as "BULLETCAM-HLVF-5-MP" and could not be found by its name. Applied after
 * the verified-spec overlay by both catalog assemblers (cameraManufacturers.ts
 * and generate-catalog-shards.mjs), so the shards and the SSG list agree. A
 * key that stops matching fails catalogNameFixes.test.ts.
 */
export const CATALOG_NAME_FIXES: Readonly<Record<string, string>> = {
  'Ajax|BULLETCAM-HLVF-5-MP': 'BulletCam HLVF (5 MP)',
  'Ajax|BULLETCAM-HLVF-8-MP': 'BulletCam HLVF (8 MP)',
  'Ajax|TURRETCAM-HLVF-5-MP': 'TurretCam HLVF (5 MP)',
  'Ajax|TURRETCAM-HLVF-8-MP': 'TurretCam HLVF (8 MP)',
  'Ajax|SUPERIOR-TURRETCAM-HLVF-4-MP': 'Superior TurretCam HLVF (4 MP)',
};

export function applyCatalogNameFixes<B extends { name: string; models: Array<{ name: string }> }>(brands: B[]): B[] {
  return brands.map((brand) => {
    let changed = false;
    const models = brand.models.map((m) => {
      const fixed = CATALOG_NAME_FIXES[`${brand.name}|${m.name}`];
      if (!fixed) return m;
      changed = true;
      return { ...m, name: fixed };
    });
    return changed ? { ...brand, models } : brand;
  });
}
